export default __webpack_public_path__ + "static/media/ocr-page-upload.76be2592.gif";